import styled from 'styled-components';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import { useContext } from 'react';
import { FileContext } from '../../../context/FileContext';
import { useMemo } from 'react';
import { useColumnOrder } from '../../../hooks/useColumnOrder';
import { useEffect } from 'react';
import { useState } from 'react';
import { AddColumnDialogue } from '../../AddColumnDialogue';
import { createNewEmailColumn } from '../../../services/monday';
import { isSignerEligibleColumn, resolveMondayColumnType } from '../../../utils/signer-column-eligibility';
import Tipseen from 'monday-ui-react-core/dist/Tipseen';
import TipseenContent from 'monday-ui-react-core/dist/TipseenContent';

const StyledDropdownForAssignEmail = styled(Dropdown)`
  width: 167px;
`;

const AssignEmailControllers = ({
  t,
  hideTipseen,
  selectedItem,
  addedFormFields,
  updateFormFields,
}) => {
  const [showTipseen, setShowTipseen] = useState(hideTipseen ? false : true);

  const { boardData, userId, setUpdateSignOrderList, boardId, isInitialLoad } =
    useContext(FileContext);
  const { updateSignersSettings, signersSettings, COLOR_CODES } =
    useColumnOrder();

  const [showAddEmailDialog, setshowAddEmailDialog] = useState(false);

  const ColorBox = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <rect width="100%" height="100%" fill={color} />
    </svg>
  );

  const columnOptions = useMemo(() => {
    const colorMapper = {};
    // add ids with already assigned data
    signersSettings?.signers?.forEach((item) => {
      colorMapper[item.emailColumnId] = item.color;
    });
    // add ids from board data whose ids are not assigned with a random color
    boardData?.columns
      ?.filter((col) => isSignerEligibleColumn(col))
      .forEach((item) => {
        if (!colorMapper.hasOwnProperty(item.id)) {
          colorMapper[item.id] = COLOR_CODES.filter(
            (x) => !Object.values(colorMapper).includes(x),
          )[0];
        }
      });
    // add me column id if me is not already assigned
    if (!colorMapper.hasOwnProperty(userId)) {
      colorMapper[userId] = COLOR_CODES.filter(
        (x) => !Object.values(colorMapper).includes(x),
      )[0];
    }

    let columns =
      boardData?.columns
        ?.filter((col) => isSignerEligibleColumn(col))
        ?.map((emailCol) => ({
          value: emailCol.id,
          label: emailCol.title,
          color: colorMapper[emailCol.id],
          type: resolveMondayColumnType(emailCol) ?? emailCol.type,
          leftIcon: () => <ColorBox color={colorMapper[emailCol.id]} />,
        })) || [];
    if (Array.isArray(columns)) {
      columns.unshift({
        value: userId,
        label: 'Me',
        color: colorMapper[userId],
        leftIcon: () => <ColorBox color={colorMapper[userId]} />,
        userId: userId,
      });
    }
    if (Array.isArray(columns)) {
      columns.push({
        value: 'add-new-column',
        label: `+ ${t('Add new column')}`,
        onClick: () => {
          setshowAddEmailDialog(true);
        },
      });
    }
    return columns;
  }, [boardData, userId, signersSettings]);

  function handleAssignColumn(value, delay = 0) {
    if (value?.onClick) {
      return setTimeout(() => {
        value.onClick();
      }, delay);
    }

    updateSignersSettings(value); // set column in signersSettings.
    selectedItem.color = value.color;
    selectedItem.signer = value;
    updateFormFields([...addedFormFields]);
    setUpdateSignOrderList(true);
  }

  // handle email label if changed from monday board
  const signerValue = (signer) => {
    return columnOptions.find((x) => x.value === signer?.value);
  };

  const handleCloseDialogue = () => {
    setshowAddEmailDialog(false);
  };

  useEffect(() => {
    if (!selectedItem.signer) {
      // set default column as email column else people column
      const emailCols = columnOptions?.filter((c) => c?.type === 'email');
      const peopleCols = columnOptions?.filter((c) => c?.type === 'people');

      if (emailCols.length > 0) {
        handleAssignColumn(emailCols[0], 2000);
      } else if (peopleCols.length > 0) {
        handleAssignColumn(peopleCols[0], 2000);
      }
    }
  }, [selectedItem, columnOptions]);

  return (
    <>
      {showAddEmailDialog ? (
        <AddColumnDialogue
          type="email"
          boardId={boardId}
          createFunction={createNewEmailColumn}
          handleClose={handleCloseDialogue}
        />
      ) : null}
      {showTipseen && isInitialLoad ? (
        <Tipseen
          className="custom__tipseen"
          hideCloseButton
          content={
            <span>
              <TipseenContent
                submitButtonText={'Dismiss'}
                onSubmit={() => setShowTipseen(false)}
              >
                Assign Signer to a signature place holder by selecting a
                recipient email column from your board.
              </TipseenContent>
            </span>
          }
          theme="primary"
        >
          <StyledDropdownForAssignEmail
            clearable={false}
            options={columnOptions}
            value={signerValue(selectedItem.signer)}
            placeholder={t('Assign To')}
            size={Dropdown.size.SMALL}
            className="dropdown-stories-styles_with-chips"
            onChange={handleAssignColumn}
          />
        </Tipseen>
      ) : (
        <StyledDropdownForAssignEmail
          clearable={false}
          options={columnOptions}
          value={signerValue(selectedItem.signer)}
          placeholder={t('Assign To')}
          size={Dropdown.size.SMALL}
          className="dropdown-stories-styles_with-chips"
          onChange={handleAssignColumn}
        />
      )}
    </>
  );
};

export default AssignEmailControllers;
